import { createSlice } from "@reduxjs/toolkit";
import reducers from "./reducers";
import { AttributeState } from "./types";

export const initialState: AttributeState = {
  selectedOptions: {},
};
const attributionSlice = createSlice({
  name: "attribution",
  initialState,
  reducers,
});

const { actions } = attributionSlice;
export { actions };

export default attributionSlice;
